import { render, staticRenderFns } from "./RamsApprove.vue?vue&type=template&id=07d70eeb&"
import script from "./RamsApprove.vue?vue&type=script&lang=js&"
export * from "./RamsApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports